import { apiDelete, apiGet, apiPost, apiPut } from './http'

export const findAll = async (params = {}) =>
  apiGet('/concepts', { auth: true, config: { params } })

export const findById = async id => apiGet(`/concepts/${id}`, { auth: true })

export const create = async payload => apiPost('/concepts', payload, { auth: true })

export const update = async ({ id, ...payload }) =>
  apiPut(`/concepts/${id}`, payload, { auth: true })

export const remove = async id => apiDelete(`/concepts/${id}`, { auth: true })
